<ng-container *hasPermission="'branches.view'">
  @if (!hostHidden()) {
    @if (isMobile()) {
      <button mat-stroked-button class="branch-picker__btn" type="button" (click)="onMobileTap()">
        <mat-icon class="branch-picker__icon">apartment</mat-icon>
        <span class="branch-picker__label">{{ activeBranchName() ?? 'All branches' }}</span>
        <mat-icon class="branch-picker__caret">expand_more</mat-icon>
      </button>
    } @else {
      <button mat-stroked-button class="branch-picker__btn" type="button" [matMenuTriggerFor]="menu">
        <mat-icon class="branch-picker__icon">apartment</mat-icon>
        <span class="branch-picker__label">{{ activeBranchName() ?? 'All branches' }}</span>
        <mat-icon class="branch-picker__caret">expand_more</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="selectBranch(null)">All branches</button>
        @for (b of branches(); track trackByBranchId($index, b)) {
          <button mat-menu-item (click)="selectBranch(b.id)">
            {{ b.name }}
          </button>
        }
      </mat-menu>
    }
  }
</ng-container>
